import {Observable, zip as observableZip} from 'rxjs';

import {filter, first, publishLast, refCount} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {SystemConfigurationService} from "../configuration/services/system.configuration.service";
import {LogService} from "../log/log.service";
import {ThemeService} from "./theme.service";

@Injectable()
export class EnvInitializer implements Resolve<any> {
  private combinedObservable: Observable<any>;

  constructor(private sysCfg: SystemConfigurationService, private logService: LogService, private themeService: ThemeService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.combinedObservable = observableZip(
      this.logService.getUserData(),
      this.sysCfg.getSystemConfiguration(),
      this.themeService.getTheme()
    ).pipe(filter(x => undefined !== x), first(), publishLast(), refCount());
  }
}

